import { ToggleButton, ToggleButtonGroup, toggleButtonClasses } from "@mui/material";
import {  Moderation } from "../types";
import { alpha,  } from '@mui/material/styles';

interface Props {
    value: Moderation;
    onChange?: (newValue: Moderation) => void
}

export const ModerateControl = (props: Props) => {
    const { value, onChange } = props;

    const handleChange = (event: any, newValue: Moderation) => {
        console.log("onChange", value, "=>", newValue);
        onChange?.(newValue)
    }

    return (
        <ToggleButtonGroup value={value} exclusive onChange={handleChange}>
            <ToggleButton value="accepted"
                sx={{
                    [`&.${toggleButtonClasses.root}`]: {
                        border: theme => `3px solid ${alpha(theme.palette.success.dark, 0.8)} !important`,
                        color: theme => `${theme.palette.success.dark} !important`,
                    },
                    [`&.${toggleButtonClasses.selected}`]: {
                        color: theme => `${theme.palette.getContrastText(theme.palette.success.dark)} !important`,
                        backgroundColor: theme => `${theme.palette.success.main} !important`,
                    }
                }}
            >
                Accepted
            </ToggleButton>
            <ToggleButton value="rejected"
                sx={{
                    [`&.${toggleButtonClasses.root}`]: {
                        border: theme => `3px solid ${alpha(theme.palette.error.dark, 0.8)} !important`,
                        color: theme => `${theme.palette.error.dark} !important`,
                    },
                    [`&.${toggleButtonClasses.selected}`]: {
                        color: theme => `${theme.palette.getContrastText(theme.palette.error.dark)} !important`,
                        backgroundColor: theme => `${theme.palette.error.main} !important`,
                    }
                }}
            >
                Rejected
            </ToggleButton>

        </ToggleButtonGroup >
    );
}